import { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './CopyableText.module.css';
import { CopyButton } from './CopyButton/CopyButton';

type TProps = {
  text: string;
  onCopy?: (text: string) => void;
  children?: ReactNode;
  textClassName?: string;
  buttonClassName?: string;
  className?: string;
  disabled?: boolean;
  testId?: string;
};

export const CopyableText = ({
  text,
  onCopy,
  children,
  buttonClassName,
  textClassName,
  className,
  disabled = false,
  testId,
}: TProps) => {
  return (
    <div className={clsx(styles.copyableText, className)}>
      {children || <p className={clsx(styles.text, textClassName)}>{text}</p>}
      {!disabled && (
        <CopyButton
          text={text}
          onCopy={onCopy}
          testId={testId}
          buttonClassName={buttonClassName}
        />
      )}
    </div>
  );
};
